export default {
  gridReact: {
    filters: 'Filters',
    columns: 'Columns',
    print: 'Print',
    noContent: 'No data to display',
    loading: 'Loading',
    customField: 'Custom field',
    left: 'Left',
    right: 'Right',
    pinColumn: 'Pin column',
    apply: 'Apply',
    clear: 'Clear',
    filter: 'Filter',
    removePin: 'Remove pin',
    columnMenu: 'Column menu',
    activeFilter: 'Active filter',
    refresh: 'Refresh',
  },
};
